// extracted by mini-css-extract-plugin
export default {"button":"button_button__0On-O","child":"button_child__DeVnn","loader":"button_loader__-rv8N","disabled":"button_disabled__nknnF"};